import React, { useEffect, useState } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
// import Chart from '../../../components/chart/Chart'
import { doc, getDoc, onSnapshot, collection, query, where, getDocs, updateDoc, serverTimestamp, arrayRemove, deleteField } from "firebase/firestore"
import { useNavigate, useParams } from "react-router-dom"
import { db, storage } from '../../../firebase'
import { Box, Breadcrumbs, Button, FormControl, InputLabel, MenuItem, Select, TextField, Typography, OutlinedInput, Chip } from '@mui/material'
// import { useTheme } from '@mui/material/styled';
import { useTheme } from '@material-ui/core/styles';
import { allRegions, allAreas, allOutlets, openList } from '../../../data/dataSource'
import { deleteObject, getDownloadURL, ref, uploadBytes, uploadBytesResumable } from 'firebase/storage'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Link from '@mui/material/Link';
import { getFunctions, httpsCallable } from "firebase/functions";
import user from '../../../assets/images/user.png'

const date = new Date().toDateString()

const Edit = () => {

  const {staffId} = useParams()


  const [ staffData, setStaffData ] = useState([])


    const [firstname, setFirstname] = useState("")
    const [lastname, setLastname] = useState("")
    const [email, setEmail] = useState("")
    const [telephone, setTelephone] = useState("")
    const [role, setRole] = useState("")
    const [address, setAddress] = useState("")
    const [gender, setGender] = useState("")
    const [dob, setDob] = useState("")
    const [state, setState] = useState("")
    const [img, setImg] = useState("")
    const [file, setFile] = useState("")
    const [staffImg, setStaffImg] = useState("")
    const [perc, setPerc] = useState(0)
    const [firstnameerror, setFirstnameerror] = useState("")
    const [lastnameerror, setLastnameerror] = useState("")
    const [emailerror, setEmailerror] = useState("")
    const [roleerror, setRoleerror] = useState("")
    const [telephoneerror, setTelephoneerror] = useState("")
    const [addresserror, setAddresserror] = useState("")
    const [gendererror, setGendererror] = useState("")
    const [doberror, setDoberror] = useState("")
    const [stateerror, setStateerror] = useState("")

    
    const [isloading, setIsloading] = useState(false)



const navigate = useNavigate()


  const getStaff = async() => {

      const docRef = doc(db, "staff", staffId);

      const docSnap = await getDoc(docRef);

    
      
      if (docSnap.exists()) {

        setStaffData(docSnap.data())
        setFirstname(docSnap.data().firstname)
        setLastname(docSnap.data().lastname)
        setEmail(docSnap.data().email)
        setRole(docSnap.data().role)
        setTelephone(docSnap.data().telephone)
        setAddress(docSnap.data().address)
        setGender(docSnap.data().gender)
        setDob(docSnap.data().dob)
        setState(docSnap.data().state)
        setImg(docSnap.data().img)

      
      } else {

        console.log("No such document!");

      }
  }



  useEffect(()=>{

    getStaff()

  }, [staffData])


    // useEffect(() => {

    //   const uploadFile = () => {
  
    //     const name = new Date().getTime() + file.name;
        
    //     const storageRef = ref(storage, name);
  
    //     const uploadTask = uploadBytesResumable(storageRef, file);
  
  
    //     uploadTask.on('state_changed', 
    //       (snapshot) => {
          
    //         const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
    //         console.log('Upload is ' + progress + '% done');
    //         setPerc(progress)
    //         switch (snapshot.state) {
    //           case 'paused':
    //             console.log('Upload is paused');
    //             break;
    //           case 'running':
    //             console.log('Upload is running');
    //             break;
    //           default:
    //             break;
    //         }
    //       }, 
    //       (error) => {
    //         console.log(error)
    //       }, 
    //       () => {
           
    //         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
    //           setImg(downloadURL)
    //         });
    //       }
    //     );
  
    //   };
  
    //   file && uploadFile();
  
    // }, [file]);




      // useEffect(() => {
      //   const uploadFile = () => {
    
      //     const name = new Date().getTime() + file.name;
          
      //     const storageRef = ref(storage, name);
    
      //     const uploadTask = uploadBytesResumable(storageRef, file);
    
    
      //     uploadTask.on('state_changed', 
      //       (snapshot) => {
            
      //         const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      //         console.log('Upload is ' + progress + '% done');
      //         setPerc(progress)
      //         switch (snapshot.state) {
      //           case 'paused':
      //             console.log('Upload is paused');
      //             break;
      //           case 'running':
      //             console.log('Upload is running');
      //             break;
      //           default:
      //             break;
      //         }
      //       }, 
      //       (error) => {
      //         console.log(error)
      //       }, 
      //       () => {

      //         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

      //           setImg(downloadURL)
                
      //        });
             
      //         // getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
      //         //   setImg((prev) => ({...prev, img: downloadURL}))
      //         // });
      //       }
      //     );
    
      //   };
    
      //   file && uploadFile();
    
      // }, [file]);



    useEffect(() => {

      const uploadFile = async () => {

        const name = new Date().getTime() + file.name;

        const storageRef = ref(storage, name); // Create a unique path

        // const storageRef = ref(storage, `images/${file.name}`);

        try {
          // Upload the image
          const snapshot = await uploadBytes(storageRef, file);

          console.log('Uploaded a blob or file!', snapshot);

          // Get the download URL
          const imageUrl = await getDownloadURL(snapshot.ref);

          console.log('File available at', imageUrl);

          setStaffImg(imageUrl)

          // Now save the URL to Firestore
          // await saveImageUrlToFirestore(imageUrl);

        } catch (error) {
          console.error("Error uploading image:", error);
        }
      };

      file && uploadFile()


    }, [file])





      const handleStaffUpdate = async() => {

  
      if(firstname === "") {
        return setFirstnameerror('Firstname is required')
        
      }

      if(lastname === "") {
        return setLastnameerror('Lastname is required')
      
      }

      if(telephone === "") {
        return setTelephoneerror('Telephone is required')
      
      }

      if(role === "") {
        return setRoleerror('Role is required')
        
      }


      if(address === "") {
        return setAddresserror('Address is required')
      
      }

      if(gender === "") {
        return setGendererror('Gender is required')
      
      }

      if(dob === "") {
        return setDoberror('Dob is required')
        
      }

       if(state === "") {
        return setStateerror('State is required')
        
      }

     

        setIsloading(true)

        try {
    
            // const docRef = await addDoc(collection(db, "subscribers"), {
            await updateDoc(doc(db, "staff", staffId), {
    
              firstname : firstname,
              lastname : lastname,
              telephone : telephone,
              role : role,
              date : date,
              address : address,
              gender : gender,
              dob : dob,
              state : state,
              img : staffImg,
              timeStamp: serverTimestamp(),
    
            })


           setIsloading(false)

           navigate('/staff')

                     
        } catch (error) {
    
          console.log(error.message);

          setIsloading(false)

        }
    
    
       
      }


      const deleteUrl = async() => {
    
            
                const imageRef = ref(storage, img);

                const docRef= doc(db, "staff", staffId);

                  try {
                    // 3. Delete the image from Storage
                    await deleteObject(imageRef);

                    console.log("Image deleted from storage.");

                    // 4. Delete the URL field from Firestore
                    await updateDoc(docRef, {

                      img: deleteField()

                    });

                    console.log("Image URL removed from Firestore.");

                    // Optionally, handle state updates or other UI logic here
                    alert("Image successfully removed!");

                  } catch (error) {

                    console.error("Error during removal process:", error);
                    
                    alert("Failed to remove image. See console for details.");
                  }
        
                // deleteObject(deleteRef).then(async() => {
                
                //     const photoRef = doc(db, "staff", staffId);
        
                //     await updateDoc(photoRef, {
    
                //         img: deleteField()
                //     });
        
            
                    
                //     alert("Photo removed")
            
            
                // }).catch((error) => {
    
                //     console.log(error)
    
                // });
            
      }
          
 

  return (

       <div className="new">
          <Sidebar/>
          <div className="newContainer">
          <Navbar/>
            <div className='top'>
              <div className='topLeft'><h1>Edit Chillaxia Staff</h1></div>
              
              <div className='topRight'>
              <Breadcrumbs aria-label="breadcrumb">
                <Link underline="hover" color="inherit" href="/">
                  Home
                </Link>
                <Link
                  underline="hover"
                  color="inherit"
                  href="/staff"
                >
                  Staff List
                </Link>
                <Typography color="green">Edit Details</Typography>
              </Breadcrumbs>
              </div>
            </div>
             <div>
                  {/* <span>{message}</span> */}
                </div>
            <div className='top'>
             
               
                <div className="left">
    
                  
                   {/* <span style={{color:'red', fontSize:14}}>{error && 'Email already exist'}</span> */}
    
                <div className='form'  >
                {/* <div className='formInput' > */}
    
    
                   
                      <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20, marginRight:20}}>
    
                      <TextField
                        id="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        value = {email}
                        placeholder="Enter Email"
                        type="email"
                        disabled={true}
                        style={{width:'100%'}}
                      />
    
                      {emailerror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {emailerror}</p>
                      }
                
    
                      </div>
    
                   
                    <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20}}>
    
                    <TextField
                      id="firstname"
                      onChange={(e) => setFirstname(e.target.value)}
                      value = {firstname}
                      placeholder="Enter Firstname"
                      style={{width:'100%'}}
                    />
    
                    {firstnameerror &&
                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {firstnameerror}</p>
                    }
    
                    </div>
           
                   <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20, marginRight:20}}>
    
                    <TextField
                      id="lastname"
                      onChange={(e) => setLastname(e.target.value)}
                      value = {lastname}
                      placeholder="Enter Lastname"
                      style={{width:'100%'}}
                    />
    
                    {lastnameerror &&
                    <p style={{color:'red', fontSize:10, marginVertical:5}}> {lastnameerror}</p>
                    }
    
                   </div>
                 
                  
                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20}}>
    
                      <TextField
                      id="telephone"
                      onChange={(e) => setTelephone(e.target.value)}
                      value = {telephone}
                      placeholder="+2348139444402"
                      style={{width:'100%'}}
                    />
    
                      {telephoneerror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {telephoneerror}</p>
                      }
    
    
                  </div>

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20, marginRight:20}}>
    
                      <TextField
                      id="role"
                      onChange={(e) => setRole(e.target.value)}
                      value = {role}
                      placeholder="Data Analyst"
                      style={{width:'100%'}}
                    />
    
                      {roleerror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {roleerror}</p>
                      }
    
    
                  </div>

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20}}>
    
                      <TextField
                      id="address"
                      onChange={(e) => setAddress(e.target.value)}
                      value = {address}
                      placeholder="23 Fajuyi street Ikeja"
                      style={{width:'100%'}}
                    />
    
                      {addresserror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {addresserror}</p>
                      }
    
    
                  </div>

                     <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20, marginRight:20}}>
    
                      <TextField
                      id="gender"
                      onChange={(e) => setGender(e.target.value)}
                      value = {gender}
                      placeholder="Male"
                      style={{width:'100%'}}
                    />
    
                      {gendererror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {gendererror}</p>
                      }
    
    
                  </div>

                  <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20, marginRight:20}}>
    
                      <TextField
                      id="dob"
                      onChange={(e) => setDob(e.target.value)}
                      value = {dob}
                      placeholder="12/04/1999"
                      style={{width:'100%'}}
                    />
    
                      {doberror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {doberror}</p>
                      }
    
    
                  </div>

                     <div style={{display: 'flex', flexDirection:'column', gap:10, width:'47%', marginBottom:20, marginRight:20}}>
    
                      <TextField
                      id="state"
                      onChange={(e) => setState(e.target.value)}
                      value = {state}
                      placeholder="Lagos"
                      style={{width:'100%'}}
                    />
    
                      {stateerror &&
                      <p style={{color:'red', fontSize:10, marginVertical:5}}> {stateerror}</p>
                      }
    
    
                  </div>

                   <div style={{display: 'flex', width:'47%', marginBottom:20, backgroundColor:'#eee', justifyContent:'center', paddingTop:10, paddingBottom:10}}>

                    {/* <span>{file}</span> */}

                           <div 

                              style={{
                                 display: 'flex',
                                width: 102,
                                height: 102,
                                borderRadius: '50%',
                                backgroundColor: 'gray',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                              }}

                           >

                            {
                              img

                              ?

                               <img
                                src={img ? img : user}
                                alt=""
                                style={{
                                  width: 100,
                                  height: 100,
                                  borderRadius:'50%'
                                }}
                              />

                              :

                              <img
                                src={file 
                                  ? URL.createObjectURL(file) 
                                  : user}
                                alt=""
                                  style={{
                                  width: 100,
                                  height: 100,
                                  borderRadius:'50%'
                                }}
                              />
                            }
                  
                             

                               {
                                  img

                                  ?

                                  <Link
                                    onClick={deleteUrl}
                                    to={"#"}
                                    style={{backgroundColor:'red', alignItems:'center', justifyContent:'center', display:'flex', color:'black', fontWeight:'bold',  position: 'absolute', right: -10, top: 30, borderRadius:10, width:30, height:30, cursor:'pointer'}}
                                  >
                                      <span style={{color:'#eee'}}>X</span>
                                  </Link>

                             
                                  :

                                  <div style={{

                                  position: 'absolute',
                                  right: -20,
                                  top: 30,

                                  }}
                                  
                                  >
                                
                                  <label htmlFor='file'>

                                  < CameraAltIcon style={{width:40, height:40, cursor:'pointer'}}/>

                                  </label>

                                  {/* <input type="file" id="file" value={file} onChange= {e => setFile(e.target.value)} style={{display:'none'}}/> */}
                                   <input type="file" id="file" onChange= {e => setFile(e.target.files[0])} style={{display:'none'}}/>

                                </div>
                                  
                                }


                            
                          
                                      
                          </div>

                   </div>

                    <Button 
                    onClick={handleStaffUpdate}
                    // disabled={perc !== null && perc < 100}
                    style={{width:'95%', backgroundColor:'rgb(15, 31, 175)', paddingTop:10, paddingBottom:10, color:'white'}}>{isloading ? "...Loading": 'Update Staff'}
                    </Button>
                </div>
                </div>
              </div>
            </div>
          </div>
 
  )
}

export default Edit